import { Component, Input, AfterViewInit, HostListener, ViewChild, ElementRef, TemplateRef, ViewContainerRef, ViewEncapsulation, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import { CalltoactionService } from './calltoaction.service';
import { UtilityService } from '@irb-common/services/utility.service';

@Component({ standalone: false,
  selector: 'calltoaction',
  templateUrl: './calltoaction.component.html',
  styleUrls: ['./calltoaction.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class CalltoactionComponent implements AfterViewInit {
  @ViewChild('calltoaction') calltoaction: ElementRef;
  @ViewChild('calltoactionView') calltoactionView: ViewContainerRef;
  @ViewChild('calltoactionArrow') calltoactionArrow: ElementRef;
  @Input() template: TemplateRef<any>;
  @Input() ref: ElementRef;
  @Input() position: string;
  defaultPosition: string;
  @Input() event: any;
  @Input() closeOnOutsideClick: boolean = true;
  @Input() maxWidth: string = '300px';
  @Input() useTruncationParent: boolean;
  @Input() verticalOffset: number;
  @Input() horizontalOffset: number;
  @Input() keepWithinBoundary: boolean = false;
  @Input() usesHover: boolean = false;
  top: number = 0;
  left: number = 0;
  arrow_left: number = 0;
  rect: any;

  constructor(private cdRef:ChangeDetectorRef, private ctas: CalltoactionService, private util: UtilityService) { }

  ngAfterViewInit(): void {
    this.defaultPosition = this.position;
    this.rect = this.calltoaction.nativeElement.getBoundingClientRect();
    this.redraw();
  }

  redraw() {
    this.updatePosition(this.event);
  }

  updatePosition(e?: any, positionOverride?: Array<string>) {
    if(typeof e === "undefined") {
      return;
    }

    const positions = (positionOverride) ? [].concat(positionOverride) : ["bottom", "top", "left", "right"];
    this.position = (positionOverride && positionOverride.length > 0) ? positionOverride.shift() : this.defaultPosition;
    positions.splice(positions.indexOf(this.position),1);
    positionOverride = (positionOverride && positionOverride.length > 0 && positionOverride.indexOf(this.position) === -1) ? positionOverride : positions;

    let m, t, l, b, r, w, h;
    w = this.rect.right - this.rect.left;
    h = this.rect.bottom - this.rect.top;
    let target = (e.target ? e.target : e.srcElement) as HTMLElement;

    if(this.useTruncationParent) {
      target = this.util.getEllipsisHTMLElement(target);
    }

    const targetRect = target.getBoundingClientRect();

    switch(this.position) {
      case "top":
        m = (this.calltoaction.nativeElement.offsetWidth / 2);
        t = targetRect.top - this.verticalOffset - h;
        l = targetRect.left + (target.offsetWidth / 2) - this.rect.left - m;
        b = t + h;
        r = l + w;
        
        if(this.keepWithinBoundary) {
          if(l < 0) {
            m += Math.floor(l - this.horizontalOffset);
            l = 0 + this.horizontalOffset;
            r = l + w;
          }
          
          if(r > window.innerWidth) {
            m += Math.floor(r - window.innerWidth + this.horizontalOffset);
            r = window.innerWidth - this.horizontalOffset;
            l = r - w;
          }
        }

        this.top = t;
        this.left = l;
        this.arrow_left = m;
        break;
      case "right":
        m = (this.calltoaction.nativeElement.offsetHeight / 2);
        t = targetRect.top + (target.offsetHeight / 2) - this.rect.top - m;
        l = targetRect.left + (target.offsetWidth + this.horizontalOffset) - this.rect.left;
        b = t + h;
        r = l + w;

        this.top = t;
        this.left = l;
        this.arrow_left = -12;
        break;
      case "bottom":
        m = (this.calltoaction.nativeElement.offsetWidth / 2);
        t = targetRect.top + (target.offsetHeight + this.verticalOffset) - this.rect.top;
        l = targetRect.left + (target.offsetWidth / 2) - this.rect.left - m;
        b = t + h;
        r = l + w;

        if(this.keepWithinBoundary) {
          if(l < 0) {
            m += Math.floor(l - this.horizontalOffset);
            l = 0 + this.horizontalOffset;
            r = l + w;
          }
          
          if(r > window.innerWidth) {
            m += Math.floor(r - window.innerWidth + this.horizontalOffset);
            r = window.innerWidth - this.horizontalOffset;
            l = r - w;
          }
        }

        this.top = t;
        this.left = l;
        this.arrow_left = m;
        break;
      case "left":
        m = (this.calltoaction.nativeElement.offsetHeight / 2);
        t = targetRect.top + (target.offsetHeight / 2) - this.rect.top - m;
        l = targetRect.left - this.horizontalOffset - w;
        b = t + h;
        r = l + w;

        this.top = t;
        this.left = l;
        this.arrow_left = w - 1;
        break;
    }

    if(positionOverride.length !== 0 || positionOverride.length === 0 && (this.position !== this.defaultPosition)) {
      if((t < 0) || (b > window.innerHeight) || (l < 0) || (r > window.innerWidth)) {
        this.updatePosition(e, positionOverride);
        return;
      }
    }

    this.cdRef.detectChanges();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(_event?: UIEvent): void {
    this.ctas.remove();
  }

  @HostListener('window:click', ['$event'])
  onClick(e: any): void {
    if(this.closeOnOutsideClick && !this.calltoaction.nativeElement.contains(e.target) && e.target !== this.ref.nativeElement) {
      this.ctas.remove();
    }
  }
}
